import {
  DRUPAL_NODE_DISPLAY,
  type DrupalImage,
  type DrupalNodePage,
  type DrupalReadTime,
  type DrupalTerm,
} from '@commons/types/drupal';

import ArticleNodeCard from './Card';
import ArticleNodeFeatured from './Featured';
import ArticleNodeFeaturedTile from './FeaturedTile';
import ArticleNodeLabel from './Label';
import ArticleNodeSmallCard from './SmallCard';
import ArticleNodeTeaser from './Teaser';

/**
 * Type definition of a Article node properties.
 */

export type ArticleNodeProps = DrupalNodePage & {
  date: string;
  readTime?: DrupalReadTime;
  image?: DrupalImage;
  format?: DrupalTerm;
  summary?: string;
  authors?: string;
};

/**
 * Article node component.
 *
 * Renders a component based on the display type.
 */

export const ArticleNode = (props: ArticleNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <ArticleNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Teaser:
      return <ArticleNodeTeaser {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <ArticleNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.SmallCard:
      return <ArticleNodeSmallCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Featured:
      return <ArticleNodeFeatured {...props} />;
    case DRUPAL_NODE_DISPLAY.FeaturedTile:
      return <ArticleNodeFeaturedTile {...props} />;
  }
};

export default ArticleNode;
